import React from 'react';
import usePolygonsStore from '../store/usePolygonsStore';
import usePolygonEventStore from '../store/usePolygonEventStore';
import settings, { homeTypesMapping, mortgageCalcEnabled } from '../util/config';
function LotCard({ lot }) {
    const { clickedLotId, hoveredLotId, setHoveredLotId, setHoveredPolygonIndex } = usePolygonEventStore(["clickedLotId", "hoveredLotId", "setHoveredLotId", "setHoveredPolygonIndex"]);
    const { polygons } = usePolygonsStore(["polygons"]);
    const monthlyPayment = parseFloat((lot.Properties?.EstimatedMonthlyPayment || '0')?.replace(/\,/g, ''))?.toLocaleString('us-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
    function handleLotMouseOver(mouseOverEvent, id) {
        const lotIndex = polygons.findIndex((polygon) => polygon.Properties.Id === id);
        setHoveredPolygonIndex(lotIndex);
    }
    function handleLotMouseLeave() {
        setHoveredPolygonIndex(-1);
        setHoveredLotId(undefined);
    }
    const monthPaymentHandler = (e) => {
        e.stopPropagation();
        if (lot.Properties.EstimatedMonthlyPaymentModalUrl) {
            const func = new Function(lot.Properties.EstimatedMonthlyPaymentModalUrl);
            func();
        }
    };
    return (React.createElement("li", { id: `lot-${lot.Properties.Id}`, className: `lot-card ${lot.Properties.Id == hoveredLotId || lot.Properties.Id == clickedLotId
            ? 'lot-card--active'
            : ''}`, onMouseLeave: handleLotMouseLeave, onMouseOver: (mouseOverEvent) => handleLotMouseOver(mouseOverEvent, lot.Properties.Id ?? '') },
        React.createElement("div", { className: "lot-card__wrapper", role: "group", "aria-label": "Lot" },
            React.createElement("div", { className: "lot-card__images" },
                React.createElement("img", { className: "lot-card__image", src: lot.Properties.ThumbnailUrl ??
                        (lot.Properties.Images && lot.Properties?.Images[0]) ??
                        settings.PlaceholderLotImage ??
                        '', alt: 'Address ' + lot.Properties.AddressLine1 + ' | Lot ' + lot.Properties.LotId })),
            React.createElement("div", { className: "lot-card__content" },
                React.createElement("h3", { className: "lot-card__address" },
                    React.createElement("a", { className: "lot-card__link", href: lot.Properties.ViewDetailsUrl, target: "_blank" },
                        lot.Properties.AddressLine1,
                        " | Lot ",
                        lot.Properties.LotId)),
                React.createElement("div", { className: "lot-card__home-names" },
                    React.createElement("p", { className: "lot-card__plan-name small-font" }, lot.Properties.PlanName),
                    lot.Properties.HomeType && (React.createElement("p", { className: "lot-card__home-type small-font" }, Object.keys(homeTypesMapping).find((key) => homeTypesMapping[key] === lot.Properties.HomeType)))),
                React.createElement("div", { className: "lot-card__monthly-payment" },
                    React.createElement("small", { className: "lot-card__monthly-payment-subtext" }, "Est."),
                    React.createElement("div", { className: "lot-card__monthly-payment-button__container" }, mortgageCalcEnabled ? (React.createElement("button", { className: "lot-card__monthly-payment-button", onMouseUp: monthPaymentHandler, "data-gtm": true, "data-mortgage-calc": true }, monthlyPayment)) : (React.createElement("span", { className: 'lot-card__monthly-payment-price-only' }, monthlyPayment))),
                    React.createElement("small", { className: "lot-card__monthly-payment-subtext" }, "/mo")),
                lot.Properties.CanBuyOnline &&
                    React.createElement("p", { className: "lot-card__total-price" }, lot.Properties.Price?.toLocaleString('us-US', {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    }))))));
}
export default LotCard;
